const Videos = (videos) => {
    const view = videos.posts
      .map((video) => {
        return `
        <div class="col-md-6 col-lg-4"><div class="cw-video__item">
        <div class="cw-video__item-wrapper">
        <figure class="cw-video__item-thumbnail">
  
        <img src="${video['video-thumbnail']}" alt="Image thumbnail" class="video_thumbnail">
        <a class="cw_video_open_popup_customized video-thumbnail-play load-more-video-popup" href="https://www.youtube.com/embed/${video['video-ID']}?rel=0&amp;amp;showinfo=&amp;amp;autoplay=1&amp;mute=1" video_id="${video['video-ID']}" video_autoplay="1" video_type="${video['video-type']}" video_showinfo="" video_rel="0" aria-label="Click to open video on a popup">
        <img src="${video['tile-icon']}" alt="Play Icon">
        </a>
        </figure>
        <!-- Thumbnail END -->
  
  
        <div class="cw-video__item-content">
            <div class="cw-video__item-category">${video['category']}</div>
            <div class="cw-video__item-title">${video['video-title']}</div>
            <div class="cw-video__item-author">${video['video-author']}</div>
        </div>
        <!--  Wrapper -->
        </div></div></div>
            `;
      })
      .join('');
  
    return view;
  };
  
  export default Videos;
  